import { isTMA, mockTelegramEnv, type ThemeParams } from '@telegram-apps/sdk-react';

// Fake but realistically-shaped launch parameters. tgWebAppData must be a
// raw URLSearchParams string because retrieveInitData() parses it back.
function buildMockInitData(): URLSearchParams {
    const user = {
        id: 12345678,
        first_name: 'Dev',
        last_name: 'Player',
        username: 'devplayer',
        language_code: 'en',
        allows_write_to_pm: true,
    };

    return new URLSearchParams([
        ['user', JSON.stringify(user)],
        ['auth_date', String(Math.floor(Date.now() / 1000))],
        ['signature', 'mock-signature'],
        ['hash', 'mock-hash'],
        ['query_id', 'AAH-mock-query-id'],
    ]);
}

const themeParams: ThemeParams = {
    accent_text_color: '#6ab2f2',
    bg_color: '#17212b',
    button_color: '#5288c1',
    button_text_color: '#ffffff',
    destructive_text_color: '#ec3942',
    header_bg_color: '#17212b',
    hint_color: '#708499',
    link_color: '#6ab3f3',
    secondary_bg_color: '#232e3c',
    section_bg_color: '#17212b',
    section_header_text_color: '#6ab3f3',
    subtitle_text_color: '#708499',
    text_color: '#f5f5f5',
};

export function installMockEnvIfNeeded(): void {
    if (isTMA()) {
        return;
    }

    if (import.meta.env.PROD) {
        return;
    }

    mockTelegramEnv({
        launchParams: {
            tgWebAppData: buildMockInitData(),
            tgWebAppThemeParams: themeParams,
            tgWebAppPlatform: 'tdesktop',
            tgWebAppVersion: '8.0',
        },
        onEvent(event, next) {
            if (event[0] === 'web_app_request_safe_area') {
                return;
            }
            next();
        },
    });

    if (typeof window !== 'undefined') {
        void import('eruda').then((mod) => mod.default.init()).catch(() => {});
    }
}
